import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { InlineSearchCommands } from '../enums';

export class InlineSearchAppUserInputEvent implements IEvent {
	public static readonly EventType = InlineSearchCommands.INLINE_SEARCH_APP_USER_INPUT_EVENT;

	public readonly timestamp = new Date();
	public readonly eventType = InlineSearchAppUserInputEvent.EventType;
	public readonly userInput: string;

	constructor(userInput: string) {
		this.userInput = userInput;
	}

	public static is(event: IEvent): event is InlineSearchAppUserInputEvent {
		return event.eventType === InlineSearchAppUserInputEvent.EventType as string;
	}
}